// src/features/marketAlerts/ItemSearchInput.tsx
import { useState, useEffect } from 'react';
import { useItemSearch, type ItemMatch } from './useMarketAlerts';

export function ItemSearchInput({
  onSelect,
  selectedItem,
}: {
  onSelect: (item: ItemMatch) => void;
  selectedItem: ItemMatch | null;
}) {
  const [query, setQuery] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState('');

  // Debounce — wait 300ms after typing stops before actually
  // searching, so every keystroke doesn't fire its own request.
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedQuery(query), 300);
    return () => clearTimeout(timer);
  }, [query]);

  const { data: matches, isLoading } = useItemSearch(debouncedQuery);
  const showDropdown = debouncedQuery.trim().length >= 2 && !selectedItem;

  return (
    <div className="item-search">
      <input
        className="input"
        type="text"
        value={selectedItem ? selectedItem.name : query}
        onChange={(e) => {
          setQuery(e.target.value);
          if (selectedItem) onSelect(null as unknown as ItemMatch); // typing again clears the selection
        }}
        placeholder="Type at least 2 characters…"
      />
      {showDropdown && (
        <div className="item-search__dropdown">
          {isLoading && <p className="item-search__hint">Searching…</p>}
          {!isLoading && matches?.length === 0 && <p className="item-search__hint">No matching tradeable items.</p>}
          {matches?.map((item) => (
            <button
              key={item.id}
              type="button"
              className="item-search__result"
              onClick={() => { onSelect(item); setQuery(''); }}
            >
              {item.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
